<div class="blankslate-container">
  <div class="blankslate">
    <ng-content select="blankslate-icon"></ng-content>
    <ng-content select="blankslate-heading"/>
    <ng-content select="blankslate-description"></ng-content>
    <ng-content select="blankslate-action"></ng-content>
  </div>
</div>
